import { CASE_NOUN } from 'www/constants'

const NOUN_ENDING = {
  [CASE_NOUN.dative]: 'у',
}

/**
 * Функция возвращает в строке профессию врача
 * @param {boolean} isMedic -
 * @param {string=} formNoun - падеж существительного, если не указан, то именительный
 * @returns {string} -
 */
function getProfession(isMedic, formNoun) {
  const ending = NOUN_ENDING[formNoun] || ''

  return isMedic ? `врач${ending}` : `специалист${ending}`
}

export default getProfession
